// React 19 hoists <title>/<meta>/<link> rendered here into <head>.
export default function Seo({ title, description, canonical, noindex }) {
  return (
    <>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
    </>
  );
}
